/*
 *   File : left-navigation.js
 *   Author : https://evoqins.com
 *   Description : Left navigation widget component
 *   Integrations : NA
 *   Version : 1.0.0
*/

import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

//Styles
import styles from "../../Styles/Component/navigation.module.scss";

//Custom components
import { Icon } from '../Icon';

const NAV_ITEMS = [
    {
        icon: "home",
        label: "Home",
        path: "/",
        child_path: ["/faq", "/notifications"],
    },
    {
        icon: "explore",
        label: "Explore ",
        path: "/explore",
        child_path: ["strategy-detail", "/creator-detail", "/watchlist", "/create-subscription"],
    },
    {
        icon: "portfolio",
        label: "Portfolio",
        path: "/portfolio",
        child_path: ["portfolio/detail"],
    },
    // {
    //     icon: "basket",
    //     label: "Create own Basket",
    //     path: "/basket",
    //     child_path: ["create-basket"],
    // },
    // {
    //     icon: "risk-profile",
    //     label: "Risk profile",
    //     path: "/risk-profile",
    //     child_path: ["/summary"],
    // },
    {
        icon: "subscriptions",
        label: "Subscriptions",
        path: "/subscriptions",
        child_path: [],
    },
    {
        icon: "manage-sip",
        label: "Manage SIPs",
        path: "/sip",
        child_path: [],
    },
    {
        icon: "orders",
        label: "Orders",
        path: "/orders",
        child_path: ["orders/detail"],
    },
    {
        icon: "account",
        label: "Account settings",
        path: "/account",
        child_path: ["brokers", "connect-broker", "edit-profile", "change-pin"],
    },

];

const MOBILE_NAV_ITEMS = [
    {
        icon: "home",
        label: "Home",
        path: "/",
        child_path: ["/faq"],
    },
    {
        icon: "explore",
        label: "Explore ",
        path: "/explore",
        child_path: ["strategy-detail", "/creator-detail"],
    },
    {
        icon: "portfolio",
        label: "Portfolio",
        path: "/portfolio",
        child_path: ["portfolio/detail"],
    },
    // {
    //     icon: "basket",
    //     label: "Create own Basket",
    //     path: "/basket",
    //     child_path: ["create-basket"],
    // },
    // {
    //     icon: "risk-profile",
    //     label: "Risk profile",
    //     path: "/risk-profile",
    //     child_path: ["/summary"],
    // },
    {
        icon: "subscriptions",
        label: "Subscriptions",
        path: "/subscriptions",
        child_path: [],
    },
    {
        icon: "manage-sip",
        label: "Manage SIPs",
        path: "/sip",
        child_path: [],
    },
    {
        icon: "orders",
        label: "Orders",
        path: "/orders",
        child_path: ["orders/detail"],
    },
    {
        icon: "wishlist",
        label: "Watchlist",
        path: "/watchlist",
        child_path: [],
    },
    {
        icon: "notifications",
        label: "Notifications",
        path: "/notifications",
        child_path: [],
    },
    {
        icon: "account",
        label: "Account settings",
        path: "/account",
        child_path: ["brokers", "connect-broker", "edit-profile", "change-pin"],
    },

];

const LeftNavigationWidget = (props) => {

    const navigate = useNavigate();
    const location = useLocation();

    const [hover, setHover] = useState(null);
    const [navigationItems, setNavigationItems] = useState(NAV_ITEMS);


    // handle navigate
    const _handleNavigate = (event, path) => {
        event.preventDefault();
        navigate(path);
    };


    return (
        props.type === 2 ?

            <div className="e-secondary-bg-gradient border-radius-16  rounded-bottom-0  h-100 pt-3">
                <div className='d-flex flex-column  gap-2 overflow-y-scroll overflow-x-hidden h-100 no-scrollbar px-3'>
                    {
                        MOBILE_NAV_ITEMS.map((data, key) => (
                            <a key={key}
                                href={data.path}
                                data-bs-dismiss="offcanvas"
                                className={`${data.path === location.pathname || data.child_path.some(path => location.pathname.includes(path)) ?
                                    styles.e_active_tab : styles.e_inactive_tab}
                                ${MOBILE_NAV_ITEMS.length == key + 1 ? "mb-4" : ""}
                                 d-flex gap-2 border-radius-8 cursor-pointer py-2 px-3 text-decoration-none`}
                                onClick={() => _handleNavigate(data.path)}
                                onMouseOver={() => setHover(data.path)}
                                onMouseLeave={() => setHover(null)}>
                                <Icon icon={data.path === location.pathname || hover === data.path || data.child_path.some(path => location.pathname.includes(path))
                                    ? `${data.icon}-active` : data.icon}
                                    size={"16px"} />
                                <span className='mb-0 mt-1 e-primary-font-clash-display e-font-14 e-font-weight-500 line-height-24px'>
                                    {data.label}
                                </span>
                            </a>
                        ))}
                </div>
            </div>
            :
            <div className="e-secondary-bg-gradient border-radius-16  rounded-bottom-0 ms-3 ms-lg-4 h-100 pt-3">
                <div className='d-flex flex-column  gap-2 overflow-y-scroll overflow-x-hidden h-100 no-scrollbar px-2 px-lg-3'>
                    {
                        navigationItems.map((data, key) => (
                            <a key={key}
                                href={data.path}
                                className={`${data.path === location.pathname || data.child_path.some(path => location.pathname.includes(path)) ?
                                    styles.e_active_tab : styles.e_inactive_tab}
                                ${navigationItems.length == key + 1 ? "mb-4" : ""}
                                 d-flex gap-2 border-radius-8 cursor-pointer py-2 px-2 px-lg-3 justify-content-center justify-content-lg-start text-decoration-none`}
                                onClick={(event) => _handleNavigate(event, data.path)}
                                onMouseOver={() => setHover(data.path)}
                                onMouseLeave={() => setHover(null)}>
                                <Icon icon={data.path === location.pathname || hover === data.path || data.child_path.some(path => location.pathname.includes(path))
                                    ? `${data.icon}-active` : data.icon}
                                    size={"16px"} />
                                <span className='d-none d-lg-block mb-0 mt-1 e-primary-font-clash-display e-font-14 e-font-weight-500 line-height-24px'>
                                    {data.label}
                                </span>
                            </a>
                        ))}
                </div>
            </div>
    )
}

export default LeftNavigationWidget;
